var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 22.1202C1.5 20.3828 2.08049 18.7587 3.05363 17.5971C4.02021 16.4433 5.26827 15.8613 6.5 15.8613H19.5C20.7317 15.8613 21.9798 16.4433 22.9464 17.5971C23.9195 18.7587 24.5 20.3828 24.5 22.1202C24.5 22.8286 24.2619 23.466 23.8983 23.9001C23.5412 24.3263 23.1198 24.4996 22.75 24.4996H3.25C2.88022 24.4996 2.45882 24.3263 2.10173 23.9001C1.73808 23.466 1.5 22.8286 1.5 22.1202Z",
    stroke: "#4B2D10",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5667 6.06667C17.5667 8.58877 15.5221 10.6333 13 10.6333C10.4779 10.6333 8.43335 8.58877 8.43335 6.06667C8.43335 3.54457 10.4779 1.5 13 1.5C15.5221 1.5 17.5667 3.54457 17.5667 6.06667Z",
    stroke: "#4B2D10",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ca3019673685071e98b3d317072f3ba1.svg";
export { ForwardRef as ReactComponent };